import {EldmlTransformerHelper} from "./EldmlTransformerHelper";

export function getDefaultButtonClassName() {
  return "btn btn-pure btn-default";
}

export function getThemeButtonClassName(theme: string | undefined) {
  switch (theme) {
    case "secondary":
      return "btn btn-pure white-color";

    case "error":
      return "btn btn-pure danger-color";

    case "neutral":
      return "btn btn-pure gray-color";

    default:
      return getDefaultButtonClassName();
  }
}

export class EldmlTransform {
  protected selector: JQuery<HTMLElement>;
  protected transformer: EldmlTransformerHelper;

  constructor(selector: JQuery<HTMLElement>, transformer: EldmlTransformerHelper) {
    this.selector = selector;
    this.transformer = transformer;
  }

  apply() {}
}
